import { getUrl, Post, Get, Put, Patch } from '.'

export const Filter = async body => {
  return Post(getUrl('cnps.css.order.store.filter'), body)
}

export const Detail = async body => {
  return Post(getUrl('cnps.css.order.store.detail'), body)
}

export const ConfirmChange = async body => {
  return Post(getUrl('cnps.css.order.store.confirm-change'), body)
}

export const SaApprove = async body => {
  return Post(getUrl('cnps.css.order.store.sa-approve'), body)
}

export const SaReject = async body => {
  return Post(getUrl('cnps.css.order.store.sa-reject'), body)
}

export const SaRejectContract = async body => {
  return Post(getUrl('cnps.css.order.store.sa-rejec-contract'), body)
}

export const SaRequestChange = async body => {
  return Post(getUrl('cnps.css.order.store.sa-request-change'), body)
}

export const VhApprove = async body => {
  return Post(getUrl('cnps.css.order.store.vh-approve'), body)
}

export const VhReject = async body => {
  return Post(getUrl('cnps.css.order.store.vh-reject'), body)
}

export const VhRequestChange = async body => {
  return Post(getUrl('cnps.css.order.store.vh-request-change'), body)
}
